<template>
  <IQOS
    class="gap-row-xs"
    :title="$t('serving_fee.title')"
    :enabled="isEnabled"
  >
    <BaseInput
      :placeholder="$t('serving_fee.percent_ph')"
      v-model.number="percent"
      type="number"
      :readonly="false"
      :valid="!isNaN(percent)"
      v-if="isEnabled"
      fullWidth
    />

    <p class="iqos-comment">
      {{ $t("serving_fee.comment") }}
    </p>

    <template #actions>
      <IQOSToggle v-model="isEnabled" />
    </template>

    <!-- <IQOSActions :editing="editing" @edit="showEditUI" @cancel="hideEditUI" @accept="onEditFinish" /> -->
  </IQOS>
</template>

<script>
export default {
  data() {
    return {
      valid: true,
    };
  },
  props: {
    mode: String,
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    reset() {
      if (this.cafe.serving_fee) {
        this.is_enabled = !!this.cafe.serving_fee.percent;
        this.percent = this.cafe.serving_fee.percent || null;
      }
    },
    onEditFinish() {
      this.valid = true;
      if (this.is_enabled) {
        if (!this.percent || this.percent < 0 || this.percent > 100) {
          this.valid = false;
          return;
        }
      } else {
        this.percent = 0;
      }

      this.$store.commit("setServingFeePercent", this.percent);
      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    changeEnabledState() {
      if (this.editing) {
        this.is_enabled = !this.is_enabled;
      }
    },
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isEnabled: {
      get() {
        return this.cafe.serving_fee.modes[this.mode];
      },
      set(v) {
        const opts = Object.assign({}, this.cafe.serving_fee);

        opts.modes[this.mode] = !!v;

        this.$store.commit("patchCafeGeneralData", {
          serving_fee: opts,
        });
        this.$store.dispatch("saveCafe");
      },
    },
    percent: {
      get() {
        return this.cafe.serving_fee.percent;
      },
      set(v) {
        const opts = Object.assign({}, this.cafe.serving_fee);

        opts.percent = v;

        this.$store.commit("patchCafeGeneralData", {
          serving_fee: opts,
        });
        this.$store.dispatch("saveCafe");
      },
    },
  }
};
</script>

<style scoped>
</style>